import { defineStore } from 'pinia'
import { ref } from 'vue'
import useValidate from '@/shared/lib/validate'
import { cloneDeep } from 'lodash'
import { getFilteredObjects } from '@/entities/Object'
import { DateTime } from 'ts-luxon'

export const useModel = defineStore('schedule_create', () => {
  const { required } = useValidate()

  const openForm = ref(false)
  const deviceTypes = getFilteredObjects([1])

  /* Данные формы */
  const fields: {
    group_object_list_id: number
    object_type_id: number
    output_count: number
    name: string
    description: ''
    interval: number
  } = {
    group_object_list_id: 1,
    object_type_id: 1,
    output_count: 1,
    name: '',
    description: '',
    interval: 0,
  }

  const data = ref(cloneDeep(fields))

  /* Правила валидации */
  const rules = {
    name: [(value: string) => required(value)],
  }

  /**
   * Функция очистки формы после закрытия
   */
  const closeForm = () => {
    openForm.value = false
    data.value = cloneDeep(fields)
  }

  /**
   * Установка группы пользователя по умолчанию
   * @param groupId
   */
  const setGroup = (groupId: number) => {
    data.value.group_object_list_id = groupId
  }

  /**
   * Функция генерации json в зависимости от типа
   */
  const generateJSON = () => {
    const interval = Number(data.value.interval)

    if (interval === 0) return null

    switch (data.value.object_type_id) {
      case 1:
        const output_count = Number(data.value.output_count)
        return generateJSONCabinet(interval, output_count)
      default:
        return null
    }
  }

  /**
   * Функция генерации json для типа ШУНО
   * @param interval
   * @param output_count
   */
  const generateJSONCabinet = (interval: number, output_count: number) => {
    const days = DateTime.now().daysInYear
    const startDate = DateTime.now().startOf('year')

    let json = {}
    let day = 1
    let index = 0

    while (day <= days) {
      const currentDate = startDate.plus({ day: day - 1 })
      json[index] = {
        m: currentDate.month,
        d: currentDate.day,
      }

      for (let i = 0; i < output_count; i++) {
        json[index][i] = { '0': [6, 0, 0], '1': [18, 0, 1] }
      }

      day = day + interval
      index++
    }

    return json
  }

  return {
    fields,
    data,
    rules,
    openForm,
    deviceTypes,

    closeForm,
    generateJSON,
    setGroup,
  }
})
